var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAALElEQVR42mNgGH6gurr6Pz5MkWaChuBTRB8DKA4DqgbiwIQBxdFIlUAcegAAKVC5Qc8U50QAAAAASUVORK5CYII=";
  export default img;